module.exports = __webpack_public_path__ + "img/astral-txt_8.b5c59f6a.svg";